
import { Component, Injector, OnInit } from '@angular/core';
import { LogDataService } from 'tnx-admin-service/logdata/services';
import {
    ComponentContextService, DataFormBase, EventData, FormSchemaBase, TextAreaControlSchema, TextControlSchema
} from 'tnx-shared';

@Component({
    selector: 'logdata-form',
    templateUrl: './logdata-form.component.html',
    styleUrls: ['./logdata-form.component.scss'],
    providers: [ComponentContextService],
})
export class LogDataFormComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        private _logDataService: LogDataService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._logDataService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextAreaControlSchema({
                field: 'data',
                label: '',
                mdWidth: 12,
                rows: 20
            }),
            new TextControlSchema({
                field: 'action',
                label: 'Loại hành động'
            }),
            new TextControlSchema({
                field: 'browserName',
                label: 'Tên trình duyệt'
            }),
            new TextControlSchema({
                field: 'browserVersion',
                label: 'Phiên bản trình duyệt'
            }),
            new TextControlSchema({
                field: 'publicIp',
                label: 'Địa chỉ IP public'
            }),
            new TextControlSchema({
                field: 'created',
                label: 'Thời gian tạo'
            }),
            new TextControlSchema({
                field: 'createdBy',
                label: 'Tác nhân'
            }),

        ];
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    }

    async onFormEvent(evt) {
        // các event trong form
        console.log(evt);
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
    }
}

